// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICheckDetailsDto
 */
export interface ICheckDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof ICheckDetailsDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsDto
     */
    vendor_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsDto
     */
    vendor_name?: string;
    /**
     * 
     * @type {number}
     * @memberof ICheckDetailsDto
     */
    vendor_account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsDto
     */
    check_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsDto
     */
    benefit_of?: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsDto
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsDto
     */
    check_memo?: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsDto
     */
    address_line_1?: string;
    /**
     * 
     * @type {string}
     * @memberof ICheckDetailsDto
     */
    address_line_2?: string;
}

/**
 * Check if a given object implements the ICheckDetailsDto interface.
 */
export function instanceOfICheckDetailsDto(value: object): value is ICheckDetailsDto {
    return true;
}

export function ICheckDetailsDtoFromJSON(json: any): ICheckDetailsDto {
    return ICheckDetailsDtoFromJSONTyped(json, false);
}

export function ICheckDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICheckDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'vendor_id': json['vendor_id'] == null ? undefined : json['vendor_id'],
        'vendor_name': json['vendor_name'] == null ? undefined : json['vendor_name'],
        'vendor_account_id': json['vendor_account_id'] == null ? undefined : json['vendor_account_id'],
        'check_name': json['check_name'] == null ? undefined : json['check_name'],
        'benefit_of': json['benefit_of'] == null ? undefined : json['benefit_of'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'zip': json['zip'] == null ? undefined : json['zip'],
        'check_memo': json['check_memo'] == null ? undefined : json['check_memo'],
        'address_line_1': json['address_line_1'] == null ? undefined : json['address_line_1'],
        'address_line_2': json['address_line_2'] == null ? undefined : json['address_line_2'],
    };
}

export function ICheckDetailsDtoToJSON(json: any): ICheckDetailsDto {
    return ICheckDetailsDtoToJSONTyped(json, false);
}

export function ICheckDetailsDtoToJSONTyped(value?: ICheckDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'vendor_id': value['vendor_id'],
        'vendor_name': value['vendor_name'],
        'vendor_account_id': value['vendor_account_id'],
        'check_name': value['check_name'],
        'benefit_of': value['benefit_of'],
        'city': value['city'],
        'state': value['state'],
        'zip': value['zip'],
        'check_memo': value['check_memo'],
        'address_line_1': value['address_line_1'],
        'address_line_2': value['address_line_2'],
    };
}

